import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}

export function SEOHead({
  title = 'Viper Strike United – Bangladesh eFootball Mobile Gaming Club',
  description = "Viper Strike United is Bangladesh's premier eFootball Mobile gaming club. Compete, improve skills, and dominate the virtual pitch with the VSU community.",
  keywords = 'Viper Strike United, VSU, eFootball, mobile gaming, Bangladesh, esports, tournament, leaderboard',
  ogImage = 'https://viperstrikeunited.xyz/logo.png',
  ogType = 'website',
  canonical,
}: SEOHeadProps) {
  // Keep the title as-is if it already contains the full brand name
  const siteTitle = title.includes('Viper Strike United') ? title : `${title} | Viper Strike United`;

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      
      {/* Open Graph */}
      <meta property="og:title" content="Viper Strike United" />
      <meta property="og:description" content="Bangladesh eFootball Mobile Gaming Club" />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content="https://viperstrikeunited.xyz" />
      <meta property="og:site_name" content="Viper Strike United" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Viper Strike United" />
      <meta name="twitter:description" content="Bangladesh eFootball Mobile Gaming Club" />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Organization Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Viper Strike United",
          "alternateName": "VSU",
          "url": "https://viperstrikeunited.xyz",
          "logo": "https://viperstrikeunited.xyz/logo.png",
          "sameAs": []
        })}
      </script>
    </Helmet>
  );
}
